import { GraphQLClient } from 'graphql-request';

export const client = new GraphQLClient('/api/graphql');

export const request = client.request.bind(client);
export const batchRequests = client.batchRequests.bind(client);
